import { Injectable } from '@angular/core';
// import * as FileSaver from 'file-saver';
import * as XLSX from 'XLSX';
import { Workbook } from 'exceljs';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as fs from 'file-saver';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ExcelServicesService {

  constructor(private datePipe: DatePipe) {

  }

  public exportAsExcelFile(data: any[], bindFirstName: string, title: string, role: string, header: any[], excelTitle: string, excelDownloadTitle: string,): void {

    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(excelTitle);
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, topLeftCell: 'G7', activeCell: 'A1' }
    ];

    // Add Row and formatting
    const titleRow = worksheet.addRow([title]);
    const roleRow = worksheet.addRow([role]);
    const bindFirstNameRow = worksheet.addRow([bindFirstName]);
    const subTitleRow = worksheet.addRow(['Date: ' + this.datePipe.transform(new Date(), 'dd-MMM-yyyy , hh:mm a')]);
    titleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    roleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    bindFirstNameRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    subTitleRow.font={name: 'Calibri', family: 4, size: 12, bold: false}
    // worksheet.addRow([]);
    // const subTitleRow = worksheet.addRow(['Date and Time: ' + dateTime.getDay() + "/" + dateTime.getMonth()]);
    
    worksheet.mergeCells('A1:C1');
    worksheet.mergeCells('A2:B2');
    worksheet.mergeCells('A3:B3');
    worksheet.mergeCells('A4:B4');
    // worksheet.mergeCells('A1:B4');
    // worksheet.mergeCells('A1:A2:A3:A4');
    // Blank Row
    worksheet.addRow([]);

    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '808EA9DB' },
        bgColor: { argb: '808EA9DB' }
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    worksheet.addRows(data);

    //Add column width
    worksheet.getColumn(1).width = 10;
    worksheet.getColumn(2).width = 15;
    worksheet.getColumn(3).width = 35;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 10;
    worksheet.getColumn(6).width = 10;
    worksheet.getColumn(7).width = 20;
    worksheet.getColumn(8).width = 20;
    worksheet.getColumn(9).width = 20;
    worksheet.getColumn(10).width = 30;
    worksheet.addRow([]);


    // Footer Row
    const footerRow = worksheet.addRow(['This is system generated excel sheet.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

    // Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    // Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, excelDownloadTitle + '_' + this.datePipe.transform(new Date(), 'short') + '.xlsx');
    });
  }


  public ExcelForMappingDetails(data: any[], bindFirstName: string, title: string, role: string, header: any[], excelTitle: string, excelDownloadTitle: string,): void {

    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(excelTitle);
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, topLeftCell: 'G7', activeCell: 'A1' }
    ];

    // Add Row and formatting
    const titleRow = worksheet.addRow([title]);
    const roleRow = worksheet.addRow([role]);
    const bindFirstNameRow = worksheet.addRow([bindFirstName]);
    const subTitleRow = worksheet.addRow(['Date: ' + this.datePipe.transform(new Date(), 'dd-MMM-yyyy , hh:mm a')]);
    titleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    roleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    bindFirstNameRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    subTitleRow.font={name: 'Calibri', family: 4, size: 12, bold: false}
    // worksheet.addRow([]);
    // const subTitleRow = worksheet.addRow(['Date and Time: ' + dateTime.getDay() + "/" + dateTime.getMonth()]);
    
    worksheet.mergeCells('A1:C1');
    worksheet.mergeCells('A2:B2');
    worksheet.mergeCells('A3:B3');
    worksheet.mergeCells('A4:B4');
    // worksheet.mergeCells('A1:B4');
    // worksheet.mergeCells('A1:A2:A3:A4');
    // Blank Row
    worksheet.addRow([]);

    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '808EA9DB' },
        bgColor: { argb: '808EA9DB' }
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    worksheet.addRows(data);

    //Add column width
    worksheet.getColumn(1).width = 10;
    worksheet.getColumn(2).width = 15;
    worksheet.getColumn(3).width = 25;
    worksheet.getColumn(4).width = 25;
    worksheet.getColumn(5).width = 25;
    worksheet.getColumn(6).width = 20;
    worksheet.getColumn(7).width = 25;
    worksheet.getColumn(8).width = 50;
    worksheet.getColumn(9).width = 15;
    worksheet.getColumn(10).width = 20;
    worksheet.getColumn(11).width = 15;
    worksheet.getColumn(12).width = 30;
    worksheet.getColumn(13).width = 30;
    worksheet.addRow([]);


    // Footer Row
    const footerRow = worksheet.addRow(['This is system generated excel sheet.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

    // Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    // Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, excelDownloadTitle + '_' + this.datePipe.transform(new Date(), 'short') + '.xlsx');
    });
  }

  /* Rate Delivery to PMS NewPipe */
  public ExcelRateDeliveryToPMS(data: any[], bindFirstName: string, title: string, role: string, header: any[], excelTitle: string, excelDownloadTitle: string,): void {

    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(excelTitle);
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, topLeftCell: 'G7', activeCell: 'A1' }
    ];

    // Add Row and formatting
    const titleRow = worksheet.addRow([title]);
    const roleRow = worksheet.addRow([role]);
    const bindFirstNameRow = worksheet.addRow([bindFirstName]);
    const subTitleRow = worksheet.addRow(['Date: ' + this.datePipe.transform(new Date(), 'dd-MMM-yyyy , hh:mm a')]);
    titleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    roleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    bindFirstNameRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    subTitleRow.font={name: 'Calibri', family: 4, size: 12, bold: false}

    worksheet.mergeCells('A1:C1');
    worksheet.mergeCells('A2:B2');
    worksheet.mergeCells('A3:C3');
    worksheet.mergeCells('A4:B4');
    // Blank Row
    worksheet.addRow([]);

    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '808EA9DB' },
        bgColor: { argb: '808EA9DB' }
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    worksheet.addRows(data);

    //Add column width
    worksheet.getColumn(1).width = 10;
    worksheet.getColumn(2).width = 15;
    worksheet.getColumn(3).width = 15;
    worksheet.getColumn(4).width = 30;
    worksheet.getColumn(5).width = 15;
    worksheet.getColumn(6).width = 25;
    worksheet.getColumn(7).width = 30;
    worksheet.getColumn(8).width = 30;
    worksheet.getColumn(9).width = 15;
    worksheet.getColumn(10).width = 15;
    worksheet.addRow([]);


    // Footer Row
    const footerRow = worksheet.addRow(['This is system generated excel sheet.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

    // Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    // Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, excelDownloadTitle + '_' + this.datePipe.transform(new Date(), 'short') + '.xlsx');
    });
  }

   /* Inventory Delivery to FX CRS NewPipe */
   public ExcelInvDeliveryToFXCRS(data: any[], bindFirstName: string, title: string, role: string, header: any[], excelTitle: string, excelDownloadTitle: string,): void {

    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(excelTitle);
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, topLeftCell: 'G7', activeCell: 'A1' }
    ];

    // Add Row and formatting
    const titleRow = worksheet.addRow([title]);
    const roleRow = worksheet.addRow([role]);
    const bindFirstNameRow = worksheet.addRow([bindFirstName]);
    const subTitleRow = worksheet.addRow(['Date: ' + this.datePipe.transform(new Date(), 'dd-MMM-yyyy , hh:mm a')]);
    titleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    roleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    bindFirstNameRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    subTitleRow.font={name: 'Calibri', family: 4, size: 12, bold: false}

    worksheet.mergeCells('A1:C1');
    worksheet.mergeCells('A2:B2');
    worksheet.mergeCells('A3:C3');
    worksheet.mergeCells('A4:B4');
    // Blank Row
    worksheet.addRow([]);

    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '808EA9DB' },
        bgColor: { argb: '808EA9DB' }
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    worksheet.addRows(data);

    //Add column width
    worksheet.getColumn(1).width = 7;
    worksheet.getColumn(2).width = 25;
    worksheet.getColumn(3).width = 12;
    worksheet.getColumn(4).width = 45;
    worksheet.getColumn(5).width = 25;
    worksheet.getColumn(6).width = 25;
    worksheet.getColumn(7).width = 20;
    worksheet.getColumn(8).width = 20;
    worksheet.getColumn(9).width = 20;
    worksheet.addRow([]);


    // Footer Row
    const footerRow = worksheet.addRow(['This is system generated excel sheet.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

    // Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    // Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, excelDownloadTitle + '_' + this.datePipe.transform(new Date(), 'short') + '.xlsx');
    });
  }

   /* Bookings from FX CRS to FN New Pipe */
   public ExcelBookingFXCRSToFN(data: any[], bindFirstName: string, title: string, role: string, header: any[], excelTitle: string, excelDownloadTitle: string,): void {

    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(excelTitle);
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, topLeftCell: 'G7', activeCell: 'A1' }
    ];

    // Add Row and formatting
    const titleRow = worksheet.addRow([title]);
    const roleRow = worksheet.addRow([role]);
    const bindFirstNameRow = worksheet.addRow([bindFirstName]);
    const subTitleRow = worksheet.addRow(['Date: ' + this.datePipe.transform(new Date(), 'dd-MMM-yyyy , hh:mm a')]);
    titleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    roleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    bindFirstNameRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    subTitleRow.font={name: 'Calibri', family: 4, size: 12, bold: false}

    worksheet.mergeCells('A1:D1');
    worksheet.mergeCells('A2:B2');
    worksheet.mergeCells('A3:C3');
    worksheet.mergeCells('A4:B4');
    // Blank Row
    worksheet.addRow([]);

    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '808EA9DB' },
        bgColor: { argb: '808EA9DB' }
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    worksheet.addRows(data);

    //Add column width
    worksheet.getColumn(1).width = 7;
    worksheet.getColumn(2).width = 12;
    worksheet.getColumn(3).width = 12;
    worksheet.getColumn(4).width = 12;
    worksheet.getColumn(5).width = 50;
    worksheet.getColumn(6).width = 20;
    worksheet.getColumn(7).width = 15;
    worksheet.getColumn(8).width = 25;
    worksheet.getColumn(9).width = 25;
    worksheet.getColumn(10).width = 15;
    worksheet.getColumn(11).width = 15;
    worksheet.getColumn(12).width = 20;
    worksheet.addRow([]);


    // Footer Row
    const footerRow = worksheet.addRow(['This is system generated excel sheet.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

    // Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    // Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, excelDownloadTitle + '_' + this.datePipe.transform(new Date(), 'short') + '.xlsx');
    });
  }

   /* Bookings from FN to FX CRS New Pipe */
   public ExcelBookingFNToFXCRS(data: any[], bindFirstName: string, title: string, role: string, header: any[], excelTitle: string, excelDownloadTitle: string,): void {

    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(excelTitle);
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, topLeftCell: 'G7', activeCell: 'A1' }
    ];

    // Add Row and formatting
    const titleRow = worksheet.addRow([title]);
    const roleRow = worksheet.addRow([role]);
    const bindFirstNameRow = worksheet.addRow([bindFirstName]);
    const subTitleRow = worksheet.addRow(['Date: ' + this.datePipe.transform(new Date(), 'dd-MMM-yyyy , hh:mm a')]);
    titleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    roleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    bindFirstNameRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    subTitleRow.font={name: 'Calibri', family: 4, size: 12, bold: false}

    worksheet.mergeCells('A1:D1');
    worksheet.mergeCells('A2:B2');
    worksheet.mergeCells('A3:C3');
    worksheet.mergeCells('A4:B4');
    // Blank Row
    worksheet.addRow([]);

    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '808EA9DB' },
        bgColor: { argb: '808EA9DB' }
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    worksheet.addRows(data);

    //Add column width
    worksheet.getColumn(1).width = 7;
    worksheet.getColumn(2).width = 12;
    worksheet.getColumn(3).width = 15;
    worksheet.getColumn(4).width = 15;
    worksheet.getColumn(5).width = 50;
    worksheet.getColumn(6).width = 35;
    worksheet.getColumn(7).width = 15;
    worksheet.getColumn(8).width = 25;
    worksheet.getColumn(9).width = 25;
    worksheet.getColumn(10).width = 15;
    worksheet.getColumn(11).width = 15;
    worksheet.getColumn(12).width = 20;
    worksheet.addRow([]);


    // Footer Row
    const footerRow = worksheet.addRow(['This is system generated excel sheet.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

    // Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    // Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, excelDownloadTitle + '_' + this.datePipe.transform(new Date(), 'short') + '.xlsx');
    });
  }
  //Bookings from channels to FN New Pipe 13-12-2024
  public ExcelBookingsfromChannelstoFNNewPipe(data: any[], bindFirstName: string, title: string, role: string, header: any[], excelTitle: string, excelDownloadTitle: string,): void {

    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(excelTitle);
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, topLeftCell: 'G7', activeCell: 'A1' }
    ];

    // Add Row and formatting
    const titleRow = worksheet.addRow([title]);
    const roleRow = worksheet.addRow([role]);
    const bindFirstNameRow = worksheet.addRow([bindFirstName]);
    const subTitleRow = worksheet.addRow(['Date: ' + this.datePipe.transform(new Date(), 'dd-MMM-yyyy , hh:mm a')]);
    titleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    roleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    bindFirstNameRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    subTitleRow.font={name: 'Calibri', family: 4, size: 12, bold: false}

    worksheet.mergeCells('A1:C1');
    worksheet.mergeCells('A2:B2');
    worksheet.mergeCells('A3:C3');
    worksheet.mergeCells('A4:B4');
    // Blank Row
    worksheet.addRow([]);

    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '808EA9DB' },
        bgColor: { argb: '808EA9DB' }
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    worksheet.addRows(data);

    //Add column width
    worksheet.getColumn(1).width = 10;
    worksheet.getColumn(2).width = 15;
    worksheet.getColumn(3).width = 15;
    worksheet.getColumn(4).width = 30;
    worksheet.getColumn(5).width = 15;
    worksheet.getColumn(6).width = 25;
    worksheet.getColumn(7).width = 30;
    worksheet.getColumn(8).width = 30;
    worksheet.getColumn(9).width = 15;
    worksheet.getColumn(10).width = 15;
    worksheet.getColumn(11).width = 15;
    worksheet.getColumn(12).width = 15;
    worksheet.getColumn(13).width = 15;
    worksheet.getColumn(14).width = 15;
    worksheet.addRow([]);


    // Footer Row
    const footerRow = worksheet.addRow(['This is system generated excel sheet.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

    // Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    // Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, excelDownloadTitle + '_' + this.datePipe.transform(new Date(), 'short') + '.xlsx');
    });
  }
  //DH Prodcut Summary Details Excel - Indhuja 07-03-2025
  public dhproductsummarydetails(data: any[],listfilterArrary:any[],productcountArray:any[],listproductdetailsArrary:any[],
    bindFirstName: string, title: string, role: string, header: any[],header1:any[],header2:any[], header3:any[],
    excelTitle: string, excelDownloadTitle: string,): void {

   // Create workbook and worksheet
   const workbook = new Workbook();
    //Product Count and details sheet
   const worksheet =workbook.addWorksheet("Channel Manager Count");
   const worksheet1=workbook.addWorksheet("Channel Mananger Details");
   const worksheet2=workbook.addWorksheet("Other Product Count");
   const worksheet3=workbook.addWorksheet("Other Product Details");
  

   
   worksheet.views = [
     { xSplit: 0, ySplit: 6, topLeftCell: 'G7', activeCell: 'A1' }// state: 'frozen',
   ];
/*     worksheet1.views = [
     { state: 'frozen',xSplit: 0, ySplit: 6, topLeftCell: 'F3', activeCell: 'A3' }// state: 'frozen',
   ]; */
   // Add Row and formatting
   const titleRow = worksheet.addRow([title]);
   const roleRow = worksheet.addRow([role]);
   const bindFirstNameRow = worksheet.addRow([bindFirstName]);
   const subTitleRow = worksheet.addRow(['Date: ' + this.datePipe.transform(new Date(), 'dd-MMM-yyyy , hh:mm a')]);
   titleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
   roleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
   bindFirstNameRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
   subTitleRow.font={name: 'Calibri', family: 4, size: 12, bold: false}


   worksheet.mergeCells('A1:C1');
   worksheet.mergeCells('A2:B2');
   worksheet.mergeCells('A3:C3');
   worksheet.mergeCells('A4:B4');
   // Blank Row
   // Blank Row
   worksheet.addRow([]); 
   worksheet.addRow(["Channel Manager Count"]).font={ name: 'Calibri', family: 4, size: 12, bold: true}
   worksheet1.addRow([]);
   worksheet1.addRow(["Channel Manager Details "]).font={ name: 'Calibri', family: 4, size: 12, bold: true};
   worksheet2.addRow([]); 
   worksheet2.addRow(["Other Product Count"]).font={ name: 'Calibri', family: 4, size: 12, bold: true}
   worksheet3.addRow([]); 
   worksheet3.addRow(["Other Product Details"]).font={ name: 'Calibri', family: 4, size: 12, bold: true}
 
   // Add Header Row
   const headerRow = worksheet.addRow(header);
   // Cell Style : Fill and Border
   headerRow.eachCell((cell, number) => {
     cell.alignment = {
       vertical: 'middle',
       horizontal: 'center'
     }
     cell.fill = {
       type: 'pattern',
       pattern: 'solid',
       fgColor: { argb: '808EA9DB' },
       bgColor: { argb: '808EA9DB' }
     };
     cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
   });


  

   const header1Row=worksheet1.addRow(header1);
   header1Row.eachCell((cell, number) => {
     cell.alignment = {
       vertical: 'middle',
       horizontal: 'center'
     }
     cell.fill = {
       type: 'pattern',
       pattern: 'solid',
       fgColor: { argb: '808EA9DB' },
       bgColor: { argb: '808EA9DB' }
     };
     cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
   });
   
   const header2Row=worksheet2.addRow(header2);
   header2Row.eachCell((cell, number) => {
     cell.alignment = {
       vertical: 'middle',
       horizontal: 'center'
     }
     cell.fill = {
       type: 'pattern',
       pattern: 'solid',
       fgColor: { argb: '808EA9DB' },
       bgColor: { argb: '808EA9DB' }
     };
     cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
   });

   const header3Row=worksheet3.addRow(header3);
   header3Row.eachCell((cell, number) => {
     cell.alignment = {
       vertical: 'middle',
       horizontal: 'center'
     }
     cell.fill = {
       type: 'pattern',
       pattern: 'solid',
       fgColor: { argb: '808EA9DB' },
       bgColor: { argb: '808EA9DB' }
     };
     cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
   });
   //Add column width

   worksheet.addRows(data);
   worksheet.getColumn(1).width = 10;
   worksheet.getColumn(2).width = 15;
   worksheet.getColumn(3).width = 15;
   worksheet.getColumn(4).width = 30;
   worksheet.getColumn(5).width = 15;
   worksheet.getColumn(6).width = 25;
   worksheet.getColumn(7).width = 30;
   worksheet.getColumn(8).width = 30;
   worksheet.getColumn(9).width = 15;
   worksheet.getColumn(10).width = 15;
   worksheet.getColumn(11).width = 15;
   worksheet.getColumn(12).width = 15;
   worksheet.getColumn(13).width = 15;
   worksheet.getColumn(14).width = 15;
   worksheet.addRow([]);


   worksheet1.addRows(listfilterArrary);
   worksheet1.getColumn(1).width = 10;
   worksheet1.getColumn(2).width = 15;
   worksheet1.getColumn(3).width = 15;
   worksheet1.getColumn(4).width = 30;
   worksheet1.getColumn(5).width = 15;
   worksheet1.getColumn(6).width = 25;
   worksheet1.getColumn(7).width = 30;
   worksheet1.getColumn(8).width = 30;
   worksheet1.getColumn(9).width = 15;
   worksheet1.getColumn(10).width = 15;
   worksheet1.getColumn(11).width = 15;
   worksheet1.getColumn(12).width = 15;
   worksheet1.getColumn(13).width = 15;
   worksheet1.getColumn(14).width = 15;
   worksheet1.addRow([]);

   worksheet2.addRows(productcountArray);
   worksheet2.getColumn(1).width = 10;
   worksheet2.getColumn(2).width = 15;
   worksheet2.getColumn(3).width = 15;
   worksheet2.getColumn(4).width = 30;
   worksheet2.getColumn(5).width = 15;
   worksheet2.getColumn(6).width = 25;
   worksheet2.getColumn(7).width = 30;
   worksheet2.getColumn(8).width = 30;
   worksheet2.getColumn(9).width = 15;
   worksheet2.getColumn(10).width = 15;
   worksheet2.getColumn(11).width = 15;
   worksheet2.getColumn(12).width = 15;
   worksheet2.getColumn(13).width = 15;
   worksheet2.getColumn(14).width = 15;
   worksheet2.addRow([]);

   worksheet3.addRows(listproductdetailsArrary);
   worksheet3.getColumn(1).width = 10;
   worksheet3.getColumn(2).width = 15;
   worksheet3.getColumn(3).width = 15;
   worksheet3.getColumn(4).width = 30;
   worksheet3.getColumn(5).width = 15;
   worksheet3.getColumn(6).width = 25;
   worksheet3.getColumn(7).width = 30;
   worksheet3.getColumn(8).width = 30;
   worksheet3.getColumn(9).width = 15;
   worksheet3.getColumn(10).width = 15;
   worksheet3.getColumn(11).width = 15;
   worksheet3.getColumn(12).width = 15;
   worksheet3.getColumn(13).width = 15;
   worksheet3.getColumn(14).width = 15;
   worksheet3.addRow([]);

   // Footer Row
   const footerRow = worksheet.addRow(['This is system generated excel sheet.']);
   footerRow.getCell(1).fill = {
     type: 'pattern',
     pattern: 'solid',
     fgColor: { argb: 'FFCCFFE5' }
   };
   footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, 
   bottom: { style: 'thin' }, right: { style: 'thin' } };
    // Merge Cells
   worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

   //WorkSheet1
   const footerRow1 = worksheet1.addRow(['This is system generated excel sheet.']);
   footerRow.getCell(1).fill = {
     type: 'pattern',
     pattern: 'solid',
     fgColor: { argb: 'FFCCFFE5' }
   };
   footerRow1.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, 
   bottom: { style: 'thin' }, right: { style: 'thin' } };
   // Merge Cells
   //worksheet1.mergeCells(`A${footerRow.number}:F${footerRow.number}`);


   //WorkSheet1
   const footerRow2 = worksheet2.addRow(['This is system generated excel sheet.']);
   footerRow.getCell(1).fill = {
     type: 'pattern',
     pattern: 'solid',
     fgColor: { argb: 'FFCCFFE5' }
   };
   footerRow2.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, 
   bottom: { style: 'thin' }, right: { style: 'thin' } };
   //worksheet2.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

   const footerRow3 = worksheet3.addRow(['This is system generated excel sheet.']);
   footerRow.getCell(1).fill = {
     type: 'pattern',
     pattern: 'solid',
     fgColor: { argb: 'FFCCFFE5' }
   };
   footerRow3.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, 
   bottom: { style: 'thin' }, right: { style: 'thin' } };
   //worksheet3.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

   // Generate Excel File with given name
   workbook.xlsx.writeBuffer().then((data: any) => {
     const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
     fs.saveAs(blob, excelDownloadTitle + '_' + this.datePipe.transform(new Date(), 'short') + '.xlsx');
   });
 }
 public ExcelBookingfromchanneltofxfnphaseII(data: any[], bindFirstName: string, title: string, role: string, header: any[], excelTitle: string, excelDownloadTitle: string,): void {

    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(excelTitle);
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, topLeftCell: 'G7', activeCell: 'A1' }
    ];

    // Add Row and formatting
    const titleRow = worksheet.addRow([title]);
    const roleRow = worksheet.addRow([role]);
    const bindFirstNameRow = worksheet.addRow([bindFirstName]);
    const subTitleRow = worksheet.addRow(['Date: ' + this.datePipe.transform(new Date(), 'dd-MMM-yyyy , hh:mm a')]);
    titleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    roleRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    bindFirstNameRow.font = { name: 'Calibri', family: 4, size: 12, bold: false };
    subTitleRow.font={name: 'Calibri', family: 4, size: 12, bold: false}

    worksheet.mergeCells('A1:D1');
    worksheet.mergeCells('A2:B2');
    worksheet.mergeCells('A3:C3');
    worksheet.mergeCells('A4:B4');
    // Blank Row
    worksheet.addRow([]);

    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '808EA9DB' },
        bgColor: { argb: '808EA9DB' }
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    worksheet.addRows(data);

    //Add column width
    worksheet.getColumn(1).width = 7;
    worksheet.getColumn(2).width = 12;
    worksheet.getColumn(3).width = 15;
    worksheet.getColumn(4).width = 15;
    worksheet.getColumn(5).width = 50;
    worksheet.getColumn(6).width = 35;
    worksheet.getColumn(7).width = 15;
    worksheet.getColumn(8).width = 25;
    worksheet.getColumn(9).width = 25;
    worksheet.getColumn(10).width = 15;
    worksheet.getColumn(11).width = 15;
    worksheet.getColumn(12).width = 20;
    worksheet.getColumn(13).width = 20;
    worksheet.getColumn(14).width = 20;
    worksheet.getColumn(15).width = 20;
    worksheet.addRow([]);


    // Footer Row
    const footerRow = worksheet.addRow(['This is system generated excel sheet.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

    // Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    // Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, excelDownloadTitle + '_' + this.datePipe.transform(new Date(), 'short') + '.xlsx');
    });
  }
}
